/**
* Alt Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Alt Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'alt-treatments',
    selector: function() {
      return '.' + this.className;
    },

    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      adjustServiceContentPosition();

      $( window ).on( 'resize', function() {
        adjustServiceContentPosition();
      } );

      $( '.alt-treatments-tab' ).on( 'click', function() {
        adjustServiceContentPosition();
      } );

      const mobileToggle = document.getElementById( 'mobile-dropdown-toggle' );
      const tabContainer = document.getElementById( 'tab-container' );
      const selectedTabTitle = document.getElementById( 'selected-tab-title' );

      // Mobile dropdown functionality
      if ( mobileToggle && tabContainer ) {
        mobileToggle.addEventListener( 'click', function() {
          if ( window.innerWidth < 1024 ) {
            $( tabContainer ).slideToggle();
          }
        } );

        tabContainer.querySelectorAll( 'button' ).forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            selectedTabTitle.textContent = button.textContent.trim();
            if ( window.innerWidth < 1024 ) {
              $( tabContainer ).slideToggle();
            }
          } );
        } );
      }

      function adjustServiceContentPosition() {
        if ( window.innerWidth > 1024 ) {
          $( '.alt-treatments-service-content' ).each( function() {
            const learnMoreElement = $( this ).find( '.alt-treatments-learn-more' );
            const learnMoreHeight = learnMoreElement.height();
            $( this ).css( 'transform', `translateY(${learnMoreHeight}px)` );
          } );
        } else {
          $( '.alt-treatments-service-content' ).each( function() {
            $( this ).css( 'transform', 'translateY(0)' );
          } );
        }
      }
    },

    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'alt-treatments', COMPONENT );
} )( app );
